import React, { useState } from 'react';
import { Box } from '@mui/material';
import { marketplaceMeta } from '../../theme';

// Official marketplace icons are loaded from /public/marketplace-icons/<key>.svg when those
// files are added to the project. Until then a neutral badge in the marketplace's colours is
// shown — it deliberately does not imitate the marketplaces' logos.
const FILES = { wildberries: 'wildberries.svg', ozon: 'ozon.svg', yandex_market: 'yandex_market.svg' };
const missing = new Set();

const MarketplaceIcon = ({ marketplace, size = 48, radius }) => {
  const meta = marketplaceMeta(marketplace);
  const file = FILES[marketplace];
  const [failed, setFailed] = useState(!file || missing.has(file));
  const r = radius ?? Math.round(size * 0.26);

  if (!failed) {
    return (
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL || ''}/marketplace-icons/${file}`}
        alt={meta.label}
        onError={() => {
          missing.add(file);
          setFailed(true);
        }}
        sx={{ width: size, height: size, borderRadius: `${r}px`, flexShrink: 0, display: 'block' }}
      />
    );
  }
  return (
    <Box
      role="img"
      aria-label={meta.label}
      sx={{
        width: size,
        height: size,
        borderRadius: `${r}px`,
        background: meta.gradient,
        color: '#fff',
        fontWeight: 800,
        fontSize: Math.round(size * 0.36),
        letterSpacing: '-0.02em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        userSelect: 'none',
      }}
    >
      {meta.short}
    </Box>
  );
};

export default MarketplaceIcon;
